/* globals AdLayersAPI, adLayersDFP */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * Ad Unit to render.
 */
class AdUnit extends Component {
  static defaultProps = {
    shouldRender: true,
    format: '',
    beforetext: '',
    class: '',
    seq: 0,
  };

  static propTypes = {
    name: PropTypes.string.isRequired,
    seq: PropTypes.number,
    shouldRender: PropTypes.bool,
    format: PropTypes.string,
    beforetext: PropTypes.string,
    class: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      rendered: false,
    };

    try {
      this.adInstance = new AdLayersAPI();
    } catch (err) {
      this.adInstance = false;
    }
  }

  /**
   * Render the ad unit on load if the conditions are met.
   */
  componentDidMount() {
    if (this.props.shouldRender) {
      this.renderAdUnit();
    }
  }

  componentDidUpdate() {
    if (this.props.shouldRender && ! this.state.rendered) {
      this.renderAdUnit();
    }
  }

  /**
   * Retrieve the <div> ID for the element.
   *
   * @return {String}
   */
  getElementId() {
    if ('undefined' === typeof adLayersDFP) {
      return null;
    }

    return `${adLayersDFP.adUnitPrefix}${this.props.name}`;
  }

  /**
   * Render the ad unit with Ad Layers.
   */
  renderAdUnit() {
    if (this.state.rendered || ! this.props.shouldRender) {
      return;
    }

    if (! this.adInstance || 'undefined' === typeof window.dfpAdDetails) {
      return;
    }

    const targetObj = {
      slot: this.props.name,
      pos: this.props.name,
    };

    if (0 !== this.props.seq) {
      targetObj.seq = this.props.seq;
      targetObj.pos = this.props.format;
      targetObj.slot = this.props.format;
    }

    this.adInstance.lazyLoadAd({
      slotName: this.props.name,
      format: this.props.format || this.props.name,
      targeting: targetObj,
    });

    this.setState({
      rendered: true,
    });
  }

  /**
   * Render the ad <div>. This should always be rendered since we will later use Ad Layers to load the unit.
   */
  render() {
    if ('undefined' === typeof adLayersDFP) {
      return null;
    }

    return (
      <div
        id={this.getElementId()}
        data-beforetext={this.props.beforetext}
        className={`dfp-ad ${this.props.class}`}
      />
    );
  }
}

export default AdUnit;
